import React, { useState, useEffect } from "react";
import useApiServices from "../../utils/useApiServices";
import {
  FETCH_ALL_MERCHANT_VALIDATIONS,
  FETCH_VEHICLE_BY_SERVICE_TYPE,
  GET_ALL_SID,
  GET_ALL_SID_,
  GET_ALL_SID_BY_VEHICLE,
  SAVE_AMOUNT_RULE,
} from "../../utils/constant";
import swal from "sweetalert";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CustomTip from "../../common/CustomToolTip/CustomTip";
import CloseIcon from "@mui/icons-material/Close";
import { Autocomplete, Chip, TextField } from "@mui/material";

const FrmAndRoutingRule = ({ handleClose, getAllMerchantsWithTheirRules }) => {
  const { apiCallFnforGet, apiCallFnforPost } = useApiServices();
  const [merchantList, setMerchantList] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState("");
  const [cards, setCards] = useState([
    {
      processor: "",
      sidList: [],
      selectedSid: [],
      isDenied: true, // Default to true
      requestMode: "",
      remarkMessage: "",
      txnMinAmount: "",
      txnMaxAmount: "",
    },
  ]);
  const [vehicles, setVehicles] = useState([]);
  const [payload, setPayload] = useState([]);

  const [midList, setMidList] = useState([]);
  const [priority, setPriority] = useState(0); 

  const FetchVehicleMasterByServiceCharge = async () => {
    const response = await apiCallFnforPost(FETCH_VEHICLE_BY_SERVICE_TYPE, {
      serviceType: "UPI",
    }); 
    if (response.statusCode === 200) {
      setVehicles(response?.data);
    } else {
      setVehicles([]);
    }
  };

  const getAllSIDs = async (mid, index) => {
    try {
      if (mid) {
        const response = await apiCallFnforGet(`${GET_ALL_SID_}${mid}`);
        if (response?.statusCode === 200) {
          setMidList(response?.data);
        } else if (response?.statusCode === 306) {
          setMidList([]);
        } else {
          setMidList([]);
        }
      }
    } catch (error) {
      console.error("Error fetching SIDs", error);
    }
  };

  useEffect(() => {
    getAllSIDs(selectedMerchant);
  }, [selectedMerchant]);



   const handleSidChange = (cardIndex, newSelectedSidArray) => {
    console.log(newSelectedSidArray)
    const updatedCards = [...cards]; // assuming you have cards state
    updatedCards[cardIndex].selectedSid = newSelectedSidArray;
    setCards(updatedCards); // update the state
  };

  const handleSidChange2 = (index, selectedSids) => {
    console.log(selectedSids);
    setCards((prevCards) => {
      const newCards = [...prevCards];
      //   const kjhkjkjhkj = [...newCards[index]?.selectedSid, ...selectedSids];
      newCards[index] = {
        ...newCards[index],
        selectedSid: selectedSids, // store the array of selected SIDs
      };
      return newCards;
    });
  };

  const handleRouteChange = (index, isDenied) => {
    setCards((prevCards) => {
      const newCards = [...prevCards];
      newCards[index].isDenied = isDenied;

      if (isDenied) {
        // If Denied is selected, clear processor and SID
        newCards[index].processor = "";
        newCards[index].selectedSid = [];
      }

      return newCards;
    });
  };

  const handleRequestModeChange = (index, mode) => {
    setCards((prevCards) => {
      const newCards = [...prevCards];
      newCards[index].requestMode = mode;
      return newCards;
    });
  };

  const handleRemarkChange = (index, remark) => {
    setCards((prevCards) => {
      const newCards = [...prevCards];
      newCards[index].remarkMessage = remark;
      return newCards;
    });
  };

  const handleMinAmountChange = (index, value) => {
    setCards((prevCards) => {
      const newCards = [...prevCards];
      newCards[index].txnMinAmount = value;
      return newCards;
    });
  };

  const handleMaxAmountChange = (index, value) => {
    setCards((prevCards) => {
      const newCards = [...prevCards];
      newCards[index].txnMaxAmount = value;
      return newCards;
    });
  };

  const addCard = () => {
    setCards((prevCards) => [
      ...prevCards,
      {
        processor: "",
        sidList: [],
        selectedSid: [],
        isDenied: true, // Default to true
        requestMode: "",
        remarkMessage: "",
        txnMinAmount: "",
        txnMaxAmount: "",
      },
    ]);
  };

  const removeCard = (index) => {
    setCards((prevCards) => prevCards.filter((_, i) => i !== index));
  };

  const validateAmounts = () => {
    for (const card of cards) {
      const minAmount = parseFloat(card.txnMinAmount) || 0;
      const maxAmount = parseFloat(card.txnMaxAmount) || 0;
      if (minAmount > maxAmount) {
        return false; // Validation failed
      }
    }
    return true; // Validation passed
  };

  const updatePayload = () => {
    const newPayload = cards.map((card, index) => ({
      domain: null,
      mid: selectedMerchant,
      processor: card.processor ? card.processor : "", // Update processor value
      priority: index + 1, // Set priority based on index + 1
      remarkMessage: card.remarkMessage,
      requestMode: card.requestMode,
      sidList: card?.selectedSid?.map(item=>item.id),
      isDenied: card.isDenied, // Update to isDenied
      txnMaxAmount: card.txnMaxAmount,
      txnMinAmount: card.txnMinAmount,
    }));
    setPayload(newPayload);
  };

  useEffect(() => {
    updatePayload();
  }, [cards, selectedMerchant]);

  const submitAmountListRules = async () => {
    try {
      if (!selectedMerchant) {
        return swal({
          title: "Alert",
          text: "Please select merchant",
          icon: "warning",
        });
      }

      if (!validateAmounts()) {
        return swal({
          title: "Alert",
          text: "Minimum amount should not be greater than maximum amount for any rule",
          icon: "warning",
        });
      }

      // Check if all required fields are filled
      const isAnyCardIncomplete = cards.some(
        (card) => !card.txnMinAmount || !card.txnMaxAmount || !card.requestMode
      );

      if (isAnyCardIncomplete) {
        return swal({
          title: "Alert",
          text: "Please fill in all required fields (Minimum Amount, Maximum Amount, Request Mode) for every card.",
          icon: "warning",
        });
      }

      const validationErrors = cards.some(
        (card) => !card.processor && !card.selectedSid && !card.isDenied
      );
      if (validationErrors) {
        return swal({
          title: "Alert",
          text: "Please select Processor and SID for all cards where Route is selected",
          icon: "warning",
        });
      }
      console.log(payload)
// return;
      const response = await apiCallFnforPost(SAVE_AMOUNT_RULE, payload);
      if (response?.statusCode === 200) {
        setCards([
          {
            processor: "",
            sidList: [],
            selectedSid: [],
            isDenied: true, // Reset to default
            requestMode: "",
            remarkMessage: "",
            txnMinAmount: "",
            txnMaxAmount: "",
          },
        ]);
        setPriority(0); // Reset priority
        swal({
          title: "Alert",
          text: "Transaction amount rule saved successfully",
          icon: "success",
        });
        setTimeout(() => {
          getAllMerchantsWithTheirRules();
          // handleClose();
        }, 2000);
        handleClose();
      }
    } catch (error) {
      console.error("Error submitting rules", error);
      return swal({
        title: "Alert",
        text: "Failed to save the transaction amount rule.",
        icon: "error",
      });
    }
  };

  const getAllMerchants = async () => {
    try {
      const response = await apiCallFnforGet(FETCH_ALL_MERCHANT_VALIDATIONS);
      if (response?.statusCode === 200) {
        setMerchantList(response?.data);
      }
    } catch (error) {
      console.error("Error fetching merchants", error);
      swal({
        title: "Alert",
        text: "No data found",
        icon: "warning",
      });
    }
  };

  useEffect(() => {
    getAllMerchants();
    FetchVehicleMasterByServiceCharge();
  }, []);
 

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between align-items-center">
        <div className="mb-3 col-md-3">
          <label className="form-label">Select A Merchant</label>
          <select
            name="merchantMid"
            className="form-control form-control-sm"
            value={selectedMerchant}  
            onChange={(e) => setSelectedMerchant(e.target?.value)}
          >
            <option>Select A Merchant</option>
            {merchantList?.map((mr, index) => (
              <option key={index} value={mr.mid}>
                {mr.mid} :- {mr.merchantName}
              </option>
            ))}
          </select>
        </div>

        <div className="d-flex gap-2 justify-content-end mt-3 me-4 mb-2">
          <CustomTip size="18" placement="top" title="Frm rules">
            <div className="" onClick={addCard}>
              <AddCircleOutlineIcon fontSize="large" />
            </div>
          </CustomTip>
        </div>
      </div>

      {cards.map((card, index) => (
        <div
          className="row border border-light rounded p-2 mt-2 position-relative"
          key={index}
          id="frm_card"
        >
          <button
            type="button"
            className="btn-close position-absolute top-0 end-0 m-2"
            onClick={() => removeCard(index)}
          >
            {/* <CloseIcon /> */}
          </button>
          <div>
            <div className="col-12 d-flex justify-content-center">
              <div className="col-12">
                <div className="row">
                  <div className="mb-3 col-md-3">
                    <label className="form-label">Minimum Amount</label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="Minimum amount"
                      value={card.txnMinAmount}
                      onChange={(e) =>
                        handleMinAmountChange(index, e.target.value)
                      }
                    />
                  </div>
                  <div className="mb-3 col-md-3">
                    <label className="form-label">Maximum Amount</label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="Maximum amount"
                      value={card.txnMaxAmount}
                      onChange={(e) =>
                        handleMaxAmountChange(index, e.target.value)
                      }
                    />
                  </div>

                  <div className="mb-3 col-md-3">
                    <label className="form-label">Request Mode</label>
                    <select
                      className="default-select form-control form-control-sm wide"
                      value={card.requestMode}
                      onChange={(e) =>
                        handleRequestModeChange(index, e.target.value)
                      }
                    >
                      <option value="">Choose</option>
                      <option value="S">S</option>
                      <option value="Slupi">Slupi</option>
                    </select>
                  </div>

                  <div className="mb-3 col-md-3">
                    <label className="form-label">Action</label>
                    <select
                      className="default-select form-control form-control-sm wide"
                      value={card.isDenied}
                      onChange={(e) =>
                        handleRouteChange(index, e.target.value === "true")
                      }
                    >
                      <option value={true}>Denied</option>
                      <option value={false}>Route</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {card.isDenied && (
              <div className="mb-3 col-md-3">
                <label className="form-label">Remark</label>
                <input
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="Remark"
                  value={card.remarkMessage}
                  onChange={(e) => handleRemarkChange(index, e.target.value)}
                />
              </div>
            )}

            {!card.isDenied && (
              <div className="col-12 h-auto">
                <div className="row h-auto">
                  <div style={{ marginBottom: "16px", width: "100%" }}>
                    <Autocomplete
                      multiple // Enables multiple selection
                      id={`select-sid-autocomplete-${index}`} // Unique ID for accessibility
                      options={midList}
                      getOptionLabel={(option) => `${option?.sid} :- ${option?.vehicleName}`} // How to display each option in the list
                      value={card?.selectedSid} // Controlled component: current selected values
                      onChange={(event, newValue) => {
                        console.log(newValue);
                        handleSidChange(index, newValue);
                      }}
                      renderTags={(value, getTagProps) =>
                        value.map((option,index) => { 
                          return (
                            <Chip
                              key={option?.id || index} // Use index or a unique ID if options don't have stable IDs
                              label={`${option?.sid} :- ${option?.vehicleName}`}
                               {...getTagProps({ index })}
                            />
                          );
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select SID"
                          placeholder="Search or select SIDs"
                          variant="outlined" // Or 'filled', 'standard'
                          // size="small" // Adjust size as needed
                          fullWidth
                        />
                      )}
                      disableCloseOnSelect // Keeps the dropdown open after selecting an item
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      ))}

      <div className="card-footer d-flex justify-content-between align-items-center">
        <div></div>
        <div>
          <button className="btn btn-primary" onClick={submitAmountListRules}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default FrmAndRoutingRule;
